export default function (Restangular) {
    return {
        restrict: 'E',
        scope: {
            entity: '=',
            entry: '='

        },
        link: function (scope, element) {
            scope.loading = false;

            scope.viewInvoice = function () {
                let purchase = scope.entry.values;
                if(scope.loading){
                    return false;
                }

                scope.loading = true;

                return Restangular
                    .one("invoice", purchase.id)
                    .one("pdf")
                    .withHttpConfig({responseType: 'blob'})
                    .get()
                    .then(data => {
                        scope.loading = false;

                        data = data.data ? data.data : data;

                        let fileName = 'BrainVt-'+purchase.numeration+'.pdf';
                        let a = document.createElement('a');
                        document.body.appendChild(a);
                        a.style = 'display: none';
                        let file = new Blob([data], {type: 'application/pdf'});
                        let fileURL = (window.URL || window.webkitURL).createObjectURL(file);

                        //Open
                        //window.open(fileURL);

                        // Download
                        a.href = fileURL;
                        a.download = fileName;
                        a.click();
                        (window.URL || window.webkitURL).revokeObjectURL(data);

                    });
            }
        },
        template: '<a class="btn btn-default" ng-click="viewInvoice()"><i class="fa text-primary" ng-class="{\'fa-spinner fa-pulse\': loading, \'fa-download\': !loading}"></i><md-tooltip>Download Invoice</md-tooltip></a>'
    };
};


/** WEBPACK FOOTER **
 ** ./js/directives/invoice_download.js
 **/